import { createMuiTheme } from "@material-ui/core"

import colors from "./colors"
import { index, about } from "../data/pages"

const defaultTheme = createMuiTheme({
  typography: {
    fontSize: 14,
  },
})

const theme = createMuiTheme({
  overrides: {
    MuiTypography: {
      h1: {
        textShadow: `0px 2px 4px ${colors.grey[900]}`,
      },
      gutterBottom: {
        marginBottom: "15px",
      },
    },
    MuiButton: {
      root: {
        fontWeight: 600,
        width: "190px",
      },
      containedPrimary: {
        boxShadow: "0px 2px 4px rgba(0,0,0,.5)",
        padding: "15px 0",
        "&:hover": {
          backgroundColor: colors.green[900],
          boxShadow: "0px 2px 4px rgba(0,0,0,.5)",
        },
        "&:active": {
          backgroundColor: colors.green[400],
          boxShadow: "0px 2px 4px rgba(0,0,0,.5)",
        },
      },
      containedSecondary: {
        border: `2px solid ${colors.green[700]}`,
        boxShadow: "none",
        color: colors.green[700],
        backgroundColor: colors.white[400],
        padding: "13px 0",
        "&:hover": {
          borderColor: colors.green[900],
          color: colors.green[900],
          backgroundColor: colors.white[400],
          boxShadow: "none",
        },
        "&:active": {
          borderColor: colors.green[400],
          color: colors.green[400],
          backgroundColor: colors.white[400],
          boxShadow: "none",
        },
      },
    },
    MuiAppBar: {
      root: {
        boxShadow: "none",
        marginBottom: "100px",
      },
      colorPrimary: {
        backgroundColor: colors.white[400],
      },
    },
    MuiToolbar: {
      gutters: {
        padding: "0 100px",
      },
    },
    MuiDrawer: {
      paper: {
        width: "235px",
        boxShadow: "0 2px 10px 5px rgba(0,0,0,0.5)",
      },
    },
    MuiListItem: {
      root: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  palette: {
    primary: {
      main: colors.green[700],
      dark: colors.green[900],
    },
    secondary: {
      main: colors.white[400],
    },
    text: {
      primary: colors.grey[400],
    },
    background: {
      default: colors.white[400],
    },
  },
  typography: {
    htmlFontSize: defaultTheme.typography.fontSize,
    fontSize: defaultTheme.typography.fontSize,
    fontFamily: `"Montserrat", "Arial", sans-serif`,
    h1: {
      fontWeight: 900,
      fontSize: `${70 / defaultTheme.typography.fontSize}rem`,
      color: colors.white[400],
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: `${35 / defaultTheme.typography.fontSize}rem`,
      },
    },
    h2: {
      fontSize: `${20 / defaultTheme.typography.fontSize}rem`,
      fontWeight: "700",
      color: colors.blue[400],
      letterSpacing: `${11 / defaultTheme.typography.fontSize}rem`,
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: `${15 / defaultTheme.typography.fontSize}rem`,
      },
    },
    h3: {
      fontSize: `${20 / defaultTheme.typography.fontSize}rem`,
      color: colors.grey[400],
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: `${15 / defaultTheme.typography.fontSize}rem`,
      },
    },
    subtitle1: {
      color: colors.grey[400],
      fontSize: `${20 / defaultTheme.typography.fontSize}rem`,
      lineHeight: `19/15`,
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: `${15 / defaultTheme.typography.fontSize}rem`,
      },
    },
    body1: {
      color: colors.grey[400],
      fontSize: "1rem",
      [defaultTheme.breakpoints.down("sm")]: {
        fontSize: `${12 / defaultTheme.typography.fontSize}rem`,
      },
    },
    button: {
      fontWeight: "500",
      fontSize: `${15 / defaultTheme.typography.fontSize}rem`,
      textTransform: "uppercase",
      lineHeight: `${19 / 14}`,
    },
  },
  data: {
    pages: {
      index,
      about,
    },
    emailHref: "mailto:office@efficientaccounting.ca",
    email: "office@efficientaccounting.ca",
    uiPhone: "+1-778-889-3619",
    phoneHref: "tel:+17788893619",
    craftedOrigin: "https://craftedorigin.com",
  },
  colors: colors,
})

export default theme
